import api from './api'
import type { LoginResponse, Usuario } from '@/types'

export interface LoginData {
  email: string
  senha: string
}

export interface RegisterData {
  nome: string
  email: string
  senha: string
  escritorio: {
    nome: string
    cnpj?: string
    telefone?: string
  }
}

export interface ChangePasswordData {
  senhaAtual: string
  novaSenha: string
}

export const authService = {
  /**
   * Login com email e senha
   */
  async login(data: LoginData): Promise<LoginResponse> {
    const response = await api.post('/auth/login', data)
    return response.data
  },

  /**
   * Registrar novo escritório + usuário admin
   */
  async register(data: RegisterData): Promise<LoginResponse> {
    const response = await api.post('/auth/register', data)
    return response.data
  },

  /**
   * Buscar dados do usuário logado
   */
  async me(): Promise<Usuario> {
    const response = await api.get('/auth/me')
    return response.data
  },

  /**
   * Logout - invalidar refresh token
   */
  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout')
    } catch (error) {
      // Ignora erro de logout
    }
  },

  /**
   * Trocar senha
   */
  async changePassword(data: ChangePasswordData): Promise<void> {
    await api.post('/auth/change-password', data)
  },

  /**
   * Refresh token
   */
  async refresh(refreshToken: string): Promise<{ accessToken: string }> {
    const response = await api.post('/auth/refresh', { refreshToken })
    return response.data
  },
}

export default authService

